import apis from '@/pages/data-panel/flow-insight/apis';
export const VISIBLE_ACTIVITY_LST = 'VISIBLE_ACTIVITY_LST';
export const ACTIVITY_ROOMLIST = 'ACTIVITY_ROOMLIST';
const UPDATA_FLOW_PARAM = 'UPDATA_FLOW_PARAM';
const ACTIVITY_STATISTICS = 'ACTIVITY_STATISTICS';
const ROOM_STATISTICS = 'ROOM_STATISTICS';
const SET_FLOW_NAME = 'SET_FLOW_NAME';
const SET_INDEX = 'SET_INDEX';
const SET_LOADING_STATUUS = 'SET_LOADING_STATUUS';
const RESET_DATA = 'RESET_DATA';
const DATA_LOADING = 'DATA_LOADING';
export const activityFlowStatistics = (param, options) => (dispatch, getState) => {
  dispatch({
    type: DATA_LOADING,
    payload: true,
  });
  apis.activityFlowStatistics(param).then((res) => {
    if (options.isCancle) return;
    if (res && res.ret === '0') {
      dispatch({
        type: ACTIVITY_STATISTICS,
        payload: res.data,
      });
    } else {
      dispatch({
        type: ACTIVITY_STATISTICS,
        payload: {},
      });
    }
  });
};

export const roomFlowStatistics = (param, options) => (dispatch, getState) => {
  dispatch({
    type: SET_LOADING_STATUUS,
    payload: true,
  });
  apis.roomFlowStatistics(param).then((res) => {
    if (options.isCancle) return;
    if (res && res.ret === '0') {
      dispatch({
        type: ROOM_STATISTICS,
        payload: res.data,
      });
    } else {
      dispatch({
        type: ROOM_STATISTICS,
        payload: {},
      });
    }
    dispatch({
      type: SET_LOADING_STATUUS,
      payload: false,
    });
  });
};
export const visibleActivityList = (param) => (dispatch, getState) => {
  apis.visibleActivityList(param).then((res) => {
    if (res && res.ret === '0') {
      dispatch({
        type: VISIBLE_ACTIVITY_LST,
        payload: res.data,
      });
    } else {
      dispatch({
        type: VISIBLE_ACTIVITY_LST,
        payload: {},
      });
    }
  });
};

export const activityRoomList = (param) => (dispatch, getState) => {
  apis.activityRoomList(param).then((res) => {
    if (res && res.ret === '0') {
      dispatch({
        type: ACTIVITY_ROOMLIST,
        payload: res.data,
      });
    } else {
      dispatch({
        type: ACTIVITY_ROOMLIST,
        payload: {},
      });
    }
  });
};

export const updataParam = (param) => (dispatch, getState) => {
  // console.log('更新', param)
  dispatch({
    type: UPDATA_FLOW_PARAM,
    payload: param,
  });
};
export const setFlowName = (param) => (dispatch, getState) => {
  // console.log('更新', param)
  dispatch({
    type: SET_FLOW_NAME,
    payload: param,
  });
};

export const setIndex = (param) => (dispatch, getState) => {
  console.log('更新index', param);
  dispatch({
    type: SET_INDEX,
    payload: param,
  });
};

export const setLoadingStatus = (param) => (dispatch, getState) => {
  console.log('更新index', param);
  dispatch({
    type: SET_LOADING_STATUUS,
    payload: param,
  });
};

export const resetData = () => (dispatch, getState) => {
  console.log('zzzzzzzz');
  dispatch({
    type: RESET_DATA,
  });
};

const initialState = {
  totalPage: 0,
  totalCount: 0,
  // 活动列表
  activityPlans: [],
  loading: false,
  // 会场列表
  list: [],
  queryConditions: {},
  roomList: [],
  qualityAnalysis: {},
  userAnalysis: {},
  channelList: [],
  flowName: {},
  selectIndex: -1,
  loadingStatus: false,
};

export default function realActivityPlan(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case VISIBLE_ACTIVITY_LST:
      return Object.assign({}, state, payload);
    case ACTIVITY_ROOMLIST:
      return Object.assign({}, state, payload, {
        loading: false,
      });
    case UPDATA_FLOW_PARAM:
      return Object.assign({}, state, { queryConditions: payload });
    case ACTIVITY_STATISTICS:
      return Object.assign({}, state, payload, {
        loading: false,
      });
    case ROOM_STATISTICS:
      console.log('新数据', payload);
      return Object.assign({}, state, { roomList: payload.roomList ? payload.roomList : [] }, payload);
    case SET_FLOW_NAME:
      return Object.assign({}, state, { flowName: payload });
    case SET_INDEX:
      return Object.assign({}, state, { selectIndex: payload });
    case SET_LOADING_STATUUS:
      return Object.assign({}, state, { loadingStatus: payload });
    case DATA_LOADING:
      return Object.assign({}, state, { loading: payload });
    case RESET_DATA:
      return Object.assign({}, initialState);
    default:
      return state;
  }
}
